"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.articlesColumns = void 0;
const globals_1 = require("./globals");
const lists_1 = require("./lists");
exports.articlesColumns = [
    {
        id: "unid", header: (0, globals_1._)("N°"), width: 80,
        css: { "text-align": "right" }, sort: "int", hidden: false
    },
    {
        id: "idNature", header: (0, globals_1._)("Nature"), width: "160", editor: "select",
        options: lists_1.natureArticle, sort: "text"
    }, {
        id: "codeArticle", header: (0, globals_1._)("Code produit"), width: "140",
        maxlength: 12, editor: "text", sort: "text"
    }, {
        id: "designation", header: (0, globals_1._)("Désignation"), width: "400",
        height: "150", editor: "popup", sort: "text", autofill: true
        // suggest:{
        //     type:"textarea", width:420, height:120,
        //     body:{view:"textarea", attributes : { maxLength : 250}}}
    },
    {
        id: "prixVente", header: (0, globals_1._)("Prix vente"), width: "120",
        maxlength: 11, tooltip: (0, globals_1._)("Prix de vente unitaire HT"),
        editor: "text", sort: "int",
        format: function (value) {
            return webix.i18n.numberFormat(value);
        }, css: { "text-align": "right" }
    },
    {
        id: "idTVA", header: (0, globals_1._)("Code TVA"), width: "120", editor: "select",
        options: lists_1.tvaList, sort: "text"
    },
    {
        id: "articleBloque", header: (0, globals_1._)("Bloqué"), width: "80",
        tooltip: (0, globals_1._)("Produit bloqué à la vente"),
        template: "{common.checkbox()}", sort: "text",
        uncheckValue: "0", value: "0", checkValue: "1"
    },
    {
        id: "prixAchat", header: (0, globals_1._)("Prix d'achat"), width: "120",
        maxlength: 11, editor: "text", sort: "int",
        format: function (value) {
            return webix.i18n.numberFormat(value);
        }, css: { "text-align": "right" }
    }
];
